// request.js 沿用项目现有 JS 请求封装，接口边界由下方 Promise 类型约束。
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import request from './request'
import type {
  Breakdown,
  BreakdownQuery,
  Market,
  PayChannel,
  SettlementProduct,
  SettlementQuery,
  SettlementResponse,
  SettlementRow
} from '@/types/settlement'
const path = (name: string) => `/${process.env.VUE_APP_SERVENAME}/settlement/${name}`
// CHECK-211：新页面查询/卡片/导出只调用 settlement；GP 导入仍复用现有 BillModal。
export const list = (query: SettlementQuery): Promise<SettlementResponse<SettlementRow[]>> =>
  request(
    path('list'),
    { ...query, ...(query.dimensionList ? { dimensionList: query.dimensionList.join(',') } : {}) },
    'GET'
  )
export const products = (query: {
  market: Market
  scope: string
  keyword?: string
}): Promise<SettlementResponse<SettlementProduct[]>> => request(path('products'), query, 'GET')
export const payChannels = (market: Market): Promise<SettlementResponse<PayChannel[]>> =>
  request(path('pay-channels'), { market }, 'GET')
export const breakdown = (query: BreakdownQuery): Promise<SettlementResponse<Breakdown>> =>
  request(path('breakdown'), query, 'GET')
const invalidDownloadMessage = '下载文件无效，请重试'

// 仅读取有限的错误响应，避免将 HTTP 200 的业务 JSON 或登录页面保存为 Excel。
function readDownloadError(blob: Blob): Promise<string> {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onerror = () => resolve(invalidDownloadMessage)
    reader.onload = () => {
      try {
        const body: unknown = JSON.parse(String(reader.result))
        if (
          typeof body === 'object' &&
          body !== null &&
          'msg' in body &&
          typeof body.msg === 'string' &&
          body.msg.trim()
        ) {
          resolve(body.msg.slice(0, 500))
          return
        }
      } catch {
        // HTML、普通文本和截断 JSON 均使用统一错误提示，不展示响应正文。
      }
      resolve(invalidDownloadMessage)
    }
    reader.readAsText(blob.slice(0, 64 * 1024))
  })
}
export const createExport = async (query: SettlementQuery): Promise<Blob> => {
  const response: unknown = await request(path('export'), {}, 'POST_DOWNLOAD', query)
  if (!(response instanceof Blob) || response.size === 0) throw new Error(invalidDownloadMessage)
  if (/json|html|^text\//i.test(response.type)) throw new Error(await readDownloadError(response))
  return response
}
